var ae = Object.create;
var G = Object.defineProperty;
var le = Object.getOwnPropertyDescriptor;
var ce = Object.getOwnPropertyNames;
var he = Object.getPrototypeOf, de = Object.prototype.hasOwnProperty;
var $ = (i, e) => () => (e || i((e = { exports: {} }).exports, e), e.exports);
var pe = (i, e, t, s) => {
  if (e && typeof e == 'object' || typeof e == 'function') for (let r of ce(e)) !de.call(i, r) && r !== t && G(i, r, {
    get: () => e[r],
    enumerable: !(s = le(e, r)) || s.enumerable
  });
  return i;
};
var z = (i, e, t) => (t = i != null ? ae(he(i)) : {}, pe(e || !i || !i.__esModule ? G(t, 'default', {
  value: i,
  enumerable: !0
}) : t, i));
var X = $((Ge, Y) => {
  var k = 1e3, P = k * 60, E = P * 60, v = E * 24, me = v * 7, ge = v * 365.25;
  Y.exports = function(i, e) {
    e = e || {};
    var t = typeof i;
    if (t === 'string' && i.length > 0) return fe(i);
    if (t === 'number' && isFinite(i)) return e.long ? ye(i) : we(i);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(i));
  };

  function fe(i) {
    if (i = String(i), !(i.length > 100)) {
      var e = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(i);
      if (e) {
        var t = parseFloat(e[1]), s = (e[2] || 'ms').toLowerCase();
        switch (s) {
          case'years':
          case'year':
          case'yrs':
          case'yr':
          case'y':
            return t * ge;
          case'weeks':
          case'week':
          case'w':
            return t * me;
          case'days':
          case'day':
          case'd':
            return t * v;
          case'hours':
          case'hour':
          case'hrs':
          case'hr':
          case'h':
            return t * E;
          case'minutes':
          case'minute':
          case'mins':
          case'min':
          case'm':
            return t * P;
          case'seconds':
          case'second':
          case'secs':
          case'sec':
          case's':
            return t * k;
          case'milliseconds':
          case'millisecond':
          case'msecs':
          case'msec':
          case'ms':
            return t;
          default:
            return;
        }
      }
    }
  }

  function we(i) {
    var e = Math.abs(i);
    return e >= v ? Math.round(i / v) + 'd' : e >= E ? Math.round(i / E) + 'h' : e >= P ? Math.round(i / P) + 'm' : e >= k ? Math.round(i / k) + 's' : i + 'ms';
  }

  function ye(i) {
    var e = Math.abs(i);
    return e >= v ? H(i, e, v, 'day') : e >= E ? H(i, e, E, 'hour') : e >= P ? H(i, e, P, 'minute') : e >= k ? H(i, e, k, 'second') : i + ' ms';
  }

  function H(i, e, t, s) {
    var r = e >= t * 1.5;
    return Math.round(i / t) + ' ' + s + (r ? 's' : '');
  }
});
var te = $((ze, ee) => {
  function be(i) {
    t.debug = t, t.default = t, t.coerce = c, t.disable = n, t.enable = r, t.enabled = o, t.humanize = X(), t.destroy = d, Object.keys(i).forEach(l => {
      t[l] = i[l];
    }), t.names = [], t.skips = [], t.formatters = {};

    function e(l) {
      let h = 0;
      for (let p = 0; p < l.length; p++) h = (h << 5) - h + l.charCodeAt(p), h |= 0;
      return t.colors[Math.abs(h) % t.colors.length];
    }

    t.selectColor = e;

    function t(l) {
      let h, p = null, y, I;

      function m(...u) {
        if (!m.enabled) return;
        let w = m, b = Number(new Date), W = b - (h || b);
        w.diff = W, w.prev = h, w.curr = b, h = b, u[0] = t.coerce(u[0]), typeof u[0] != 'string' && u.unshift('%O');
        let C = 0;
        u[0] = u[0].replace(/%([a-zA-Z%])/g, (S, F) => {
          if (S === '%%') return '%';
          C++;
          let A = t.formatters[F];
          if (typeof A == 'function') {
            let x = u[C];
            S = A.call(w, x), u.splice(C, 1), C--;
          }
          return S;
        }), t.formatArgs.call(w, u), (w.log || t.log).apply(w, u);
      }

      return m.namespace = l, m.useColors = t.useColors(), m.color = t.selectColor(l), m.extend = s, m.destroy = t.destroy, Object.defineProperty(m, 'enabled', {
        enumerable: !0,
        configurable: !1,
        get: () => p !== null ? p : (y !== t.namespaces && (y = t.namespaces, I = t.enabled(l)), I),
        set: u => {
          p = u;
        }
      }), typeof t.init == 'function' && t.init(m), m;
    }

    function s(l, h) {
      let p = t(this.namespace + (typeof h == 'undefined' ? ':' : h) + l);
      return p.log = this.log, p;
    }

    function r(l) {
      t.save(l), t.namespaces = l, t.names = [], t.skips = [];
      let h, p = (typeof l == 'string' ? l : '').split(/[\s,]+/), y = p.length;
      for (h = 0; h < y; h++) p[h] && (l = p[h].replace(/\*/g, '.*?'), l[0] === '-' ? t.skips.push(new RegExp('^' + l.slice(1) + '$')) : t.names.push(new RegExp('^' + l + '$')));
    }

    function n() {
      let l = [...t.names.map(a), ...t.skips.map(a).map(h => '-' + h)].join(',');
      return t.enable(''), l;
    }

    function o(l) {
      if (l[l.length - 1] === '*') return !0;
      let h, p;
      for (h = 0, p = t.skips.length; h < p; h++) if (t.skips[h].test(l)) return !1;
      for (h = 0, p = t.names.length; h < p; h++) if (t.names[h].test(l)) return !0;
      return !1;
    }

    function a(l) {
      return l.toString().substring(2, l.toString().length - 2).replace(/\.\*\?$/, '*');
    }

    function c(l) {
      return l instanceof Error ? l.stack || l.message : l;
    }

    function d() {
      console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
    }

    return t.enable(t.load()), t;
  }

  ee.exports = be;
});
var V = $((f, D) => {
  f.formatArgs = ve;
  f.save = Se;
  f.load = ke;
  f.useColors = Ce;
  f.storage = Pe();
  f.destroy = (() => {
    let i = !1;
    return () => {
      i || (i = !0, console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.'));
    };
  })();
  f.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

  function Ce() {
    return typeof window != 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs) ? !0 : typeof navigator != 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document != 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window != 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator != 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator != 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }

  function ve(i) {
    if (i[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + i[0] + (this.useColors ? '%c ' : ' ') + '+' + D.exports.humanize(this.diff), !this.useColors) return;
    let e = 'color: ' + this.color;
    i.splice(1, 0, e, 'color: inherit');
    let t = 0, s = 0;
    i[0].replace(/%[a-zA-Z%]/g, r => {
      r !== '%%' && (t++, r === '%c' && (s = t));
    }), i.splice(s, 0, e);
  }

  f.log = console.debug || console.log || (() => {
  });

  function Se(i) {
    try {
      i ? f.storage.setItem('debug', i) : f.storage.removeItem('debug');
    } catch (e) {
    }
  }

  function ke() {
    let i;
    try {
      i = f.storage.getItem('debug');
    } catch (e) {
    }
    return !i && typeof process != 'undefined' && 'env' in process && (i = process.env.DEBUG), i;
  }

  function Pe() {
    try {
      return localStorage;
    } catch (i) {
    }
  }

  D.exports = te()(f);
  var { formatters: Ee } = D.exports;
  Ee.j = function(i) {
    try {
      return JSON.stringify(i);
    } catch (e) {
      return '[UnexpectedJSONParseError]: ' + e.message;
    }
  };
});
var Q = (i = 21) => crypto.getRandomValues(new Uint8Array(i)).reduce((e, t) => (t &= 63, t < 36 ? e += t.toString(36) : t < 62 ? e += (t - 26).toString(36).toUpperCase() : t > 62 ? e += '-' : e += '_', e), '');
var g = class {
  constructor(e) {
    this.element = e;
  }

  replace(e) {
    var t;
    return (t = this.element) == null || t.replaceWith(e), e;
  }

  append(e) {
    var t;
    return (t = this.element) == null || t.append(e), e;
  }

  prepend(e) {
    var t;
    return (t = this.element) == null || t.prepend(e), e;
  }

  insertBefore(e) {
    var t;
    return (t = this.element) == null || t.before(e), e;
  }

  insertAfter(e) {
    var t;
    return (t = this.element) == null || t.after(e), e;
  }

  closest(e, t = 5) {
    if (!this.element) return new g;
    if (typeof e == 'object') return this.searchByStyle(e, this.element, r => r.parentElement, t);
    let s = this.element.closest(e);
    return s ? new g(s) : new g;
  }

  find(e) {
    var s;
    let t = (s = this.element) == null ? void 0 : s.querySelector(e);
    return t ? new g(t) : new g;
  }

  searchByStyle(e, t, s, r = 5) {
    if (r < 0 || !t) return null;
    let n = getComputedStyle(t);
    if (Object.entries(e).every(([c, d]) => n.getPropertyValue(c) === d)) return new g(t);
    let a = s(t);
    return a ? this.searchByStyle(e, a, s, r - 1) : null;
  }
};
var M = class {
  constructor({ routeUtil: e }) {
    this.subscriber = [], this.routeUtil = e, this.observer = new MutationObserver(t => {
      t.reduce((s, r) => s.concat(Array.from(r.addedNodes)), []).filter(s => s instanceof Element && !s.hasAttribute('wk-skip')).forEach(s => {
        s instanceof Element && this.scan(s);
      });
    }), this.observer.observe(document, { subtree: !0, childList: !0, attributes: !1 });
  }

  watch(e, t) {
    let s = { target: e, callback: t };
    this.subscriber.push(s), Z(s, this.routeUtil.parse(window.location.pathname)) && this.scan(document);
  }

  shouldSkip(e, { skipHidden: t }) {
    return t && e instanceof HTMLElement ? e.offsetParent === null : !1;
  }

  scan(e) {
    e && this.subscriber.filter(t => Z(t, this.routeUtil.parse(window.location.pathname))).forEach(t => {
      let s = e instanceof Element && e.matches(t.target.selector) && !this.shouldSkip(e, { skipHidden: !!t.target.skipHidden });
      if (s && this.notify(t, e), s && t.target.firstMatch) return;
      let r = e.querySelectorAll(t.target.selector);
      for (let n of r) if (!this.shouldSkip(n, { skipHidden: !!t.target.skipHidden }) && (this.notify(t, n), t.target.firstMatch)) break;
    });
  }

  notify(e, t) {
    if (!t.hasAttribute('wk-skip')) {
      t.setAttribute('wk-skip', '');
      let s = new g(t);
      e.callback(s);
    }
  }
};

function Z({ target: i }, e) {
  if (!i.pageType) return !0;
  if (!e.pageType) return !1;
  let t = Array.isArray(i.pageType) ? i.pageType : [i.pageType];
  return t.includes('all') ? !0 : t.includes(e.pageType);
}

var ue = [{ pageType: 'product', match: i => i.includes('/products/') }, {
    pageType: 'collection',
    match: i => i.includes('/collections/') && !i.includes('/products/')
  }, { pageType: 'account', match: i => i.includes('/account/') || i.endsWith('/account') }, {
    pageType: 'challenge',
    match: i => i.endsWith('/account')
  }, { pageType: 'blog', match: i => i.includes('/blog/') }, {
    pageType: 'cart',
    match: i => i.includes('/cart/') || i.endsWith('/cart')
  }, { pageType: 'wishlist', match: (i, { wishlistUrl: e }) => i.includes(e) }, {
    pageType: 'page',
    match: i => i.includes('/pages/')
  }, { pageType: 'search', match: i => i.includes('/search') }, { pageType: 'home', match: i => i.length < 4 }],
  L = class {
    constructor({ wishlistUrl: e }) {
      this.wishlistUrl = e;
    }

    parse(e) {
      for (let t of ue) if (t.match(e, { wishlistUrl: this.wishlistUrl })) return { pageType: t.pageType };
      return { pageType: 'unknown' };
    }
  };
var R = class {
  constructor(e) {
    this.locale = {};
    var t;
    this.initLocale((t = e == null ? void 0 : e.locale) != null ? t : {});
  }

  initLocale(e) {
    this.locale = this.decodeLocale(e);
  }

  decodeHtmlEntities(e) {
    return e.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#39;/g, '\'');
  }

  decodeLocale(e) {
    let t = {};
    for (let s in e) {
      t[s] = {};
      for (let r in e[s]) t[s][r] = this.decodeHtmlEntities(e[s][r]);
    }
    return t;
  }

  translate(e, t) {
    var o;
    let [s, r] = e.split('.'), n = (o = this.locale[s]) == null ? void 0 : o[r];
    return n ? t ? Object.entries(t).reduce((a, [c, d]) => a.replace(new RegExp(`{{\\s*${c}\\s*}}`, 'g'), d), n) : n : `translation missing: ${e}`;
  }
};
var T = class {
  constructor({ rootUrl: e, wishlistUrl: t }) {
    this._rootUrl = e, this.route = new L({ wishlistUrl: t }), this.observer = new M({ routeUtil: this.route }), this.locale = new R, this.watch = this.observer.watch.bind(this.observer);
  }

  getPageType(e = window.location.pathname) {
    return this.route.parse(e).pageType;
  }

  getWishlistId(e) {
    if (!e) return null;
    e instanceof URL && (e = e.pathname);
    let t = e.replace(this._rootUrl, '/').split('/');
    return t.length === 4 ? t.pop() : 'mine';
  }

  getProductHandle(e) {
    var t, s;
    return e ? (e instanceof URL && (e = e.pathname), (s = (t = window.decodeURI(e).split('/').pop()) == null ? void 0 : t.split('?')[0]) == null ? void 0 : s.split('#')[0]) : null;
  }

  getVariantId(e, t) {
    var r;
    let s = null;
    if (e && (e instanceof URL && (e = e.pathname), s = new URLSearchParams(e.split('?')[1]).get('variant')), !s && t) try {
      s = new FormData((r = t.element) != null ? r : t).get('id');
    } catch (n) {
      console.warn('Failed to parse variant from product form.', n);
    }
    return s;
  }

  translate(e, t) {
    return this.locale.translate(e, t);
  }

  createComponent(e, t) {
    var r;
    let s = document.createElement(e);
    if (t != null && t.dataset && Object.entries(t == null ? void 0 : t.dataset).forEach(([n, o]) => {
      o && (typeof o == 'boolean' ? s.dataset[n] = '' : typeof o == 'object' ? s.dataset[n] = JSON.stringify(o) : s.dataset[n] = o);
    }), t != null && t.props && Object.entries(t == null ? void 0 : t.props).forEach(([n, o]) => {
      if (n === 'floating' && o) {
        let a = o, c = (a == null ? void 0 : a.reference) instanceof g ? a.reference.element : a.reference;
        if (typeof c == 'object' && 'id' in c) {
          c.setAttribute('wk-id', Q()), s[n] = { ...a, reference: `[wk-id="${c.getAttribute('wk-id')}"]` };
          return;
        }
      }
      s[n] = o;
    }), (r = t == null ? void 0 : t.wrap) != null && r.name) {
      let n = this.createElement(t.wrap.name, t.wrap.props, s);
      return n.setAttribute('wk-skip', ''), n;
    }
    return s;
  }

  createHeadlessComponent(e, t) {
    var n;
    let s = t.host.element ? t.host.element : t.host;
    if (!s) throw new Error('Headless host is undefined');
    t.dataset && Object.entries(t.dataset).forEach(([o, a]) => {
      a && (typeof a == 'boolean' ? s.dataset[o] = '' : typeof a == 'object' ? s.dataset[o] = JSON.stringify(a) : s.dataset[o] = a);
    });
    let r = (n = window.headlessElements) == null ? void 0 : n.store.get(e);
    if (!r) throw new Error(`Headless element not found: ${e}`);
    return new r(s);
  }

  createElement(e, t = {}, ...s) {
    let r = Object.assign(document.createElement(e), t);
    return s && r.append(...s), r;
  }
};
var _ = class {
  constructor() {
    this.dispatcher = document;
  }

  publish(e) {
    this.dispatcher.dispatchEvent(new CustomEvent(e.name, { detail: e, bubbles: !1, cancelable: !1 }));
  }

  once(e, t) {
    let s = r => {
      this.dispatcher.removeEventListener(e, s), t(r);
    };
    this.subscribe(e, s);
  }

  subscribe(e, t) {
    this.dispatcher.addEventListener(e, s => {
      let r = s;
      t({ name: r.type, data: r.detail.data });
    });
  }

  subscribeMany(e) {
    return Object.entries(e).map(([t, s]) => this.subscribe(t, s));
  }
};
var oe = z(V());
import { from as Te, map as re } from 'https://cdn.jsdelivr.net/npm/rxjs@7.8.0/+esm';

var se = z(V()), Ue = (0, se.default)('wk:app'), Ie = 1, ie = { storefront: `wk-storefront-v${Ie}` };
var Ae = Object.values(ie);
caches.keys().then(i => Promise.all(i.map(e => {
  if (!Ae.includes(e)) return Ue('Deleting out of date cache', { cacheName: e }), caches.delete(e);
})));
var N = class {
  constructor(e) {
    this.pending = new Map;
    this.initCache({ name: ie[e.name] });
  }

  async initCache({ name: e }) {
    try {
      this.cache = await caches.open(e);
    } catch (t) {
      console.warn('Failed to open cache.', t);
    }
  }

  async withCache(e, t, s) {
    let r = this.hashKey(e),
      n = () => s().then(async d => (this.pending.delete(r), await this.setItemInCache(r, t, d), d)),
      o = () => this.getItemInCache(r).then(async d => {
        if (d) {
          let l = this.getCacheInfo(d.headers);
          if (l.stale && l.revalidate) return this.pending.delete(r), n(), d.json().then(({ value: h }) => h);
          if (!l.stale) return this.pending.delete(r), d.json().then(({ value: h }) => h);
        }
        return n();
      }), a = this.pending.get(r);
    if (a) return a;
    let c = o();
    return this.pending.set(r, c), c;
  }

  async setItemInCache(e, t, s) {
    if (!this.cache || t === 'no-store') return s;
    let r = `https://wishlistking.dev/${e}`, n = new Request(r), o = new Response(JSON.stringify({ value: s }));
    return o.headers.set('cache-control', t), o.headers.set('cache-put-date', new Date().toUTCString()), await this.cache.put(n, o), s;
  }

  async getItemInCache(e) {
    if (!this.cache) return;
    let t = `https://wishlistking.dev/${e}`, s = new Request(t);
    return this.cache.match(s);
  }

  getCacheInfo(e) {
    var n;
    let t = { stale: !0, revalidate: !1 }, s = e.get('cache-control'), r = e.get('cache-put-date');
    return !s || !r ? t : (n = s.toLocaleLowerCase().split(',').map(o => o.trim()).reduce((o, a) => {
      var c, d;
      if (a.startsWith('max-age=')) {
        let l = parseInt((c = a.split('=').pop()) != null ? c : '0') * 1e3;
        return { ...o, stale: Date.now() - new Date(r).getTime() > l };
      }
      if (a.startsWith('stale-while-revalidate=')) {
        let l = parseInt((d = a.split('=').pop()) != null ? d : '0') * 1e3;
        return { ...o, revalidate: Date.now() - new Date(r).getTime() < l };
      }
      return o;
    }, t)) != null ? n : t;
  }

  hashKey(e) {
    let t = Array.isArray(e) ? e : [e], s = '';
    for (let r of t) r != null && (typeof r == 'object' ? s += JSON.stringify(r) : s += r.toString());
    return encodeURIComponent(s);
  }
};
var j = class {
  constructor(e) {
    this.pending = new Map;
    this.country = e.country, this.language = e.language, this.host = `https://${e.storeName}.myshopify.com/api/${e.version}/graphql.json`, this.headers = {
      accept: 'application/json',
      'content-type': 'application/json',
      'x-shopify-storefront-access-token': e.accessToken
    }, this.cache = new N({ name: 'storefront' });
  }

  loadProduct({ productId: e, metafields: t = [] }) {
    let s = `
      fragment productMetafields on Product {
        metafields(identifiers: [${t.map(r => `{namespace: "${r.namespace}", key: "${r.key}"}`).join(',')}]) {
          key
          value
        }
      }
    `;
    return this.fetch({
      cacheStrategy: 'public, max-age=10, stale-while-revalidate=30', body: JSON.stringify({
        query: `
          query @inContext(language: ${this.language}, country: ${this.country}) {
            product(id: "gid://shopify/Product/${e}") {
              ...productFields
              ...productMetafields
            }
          }
          ${Fe}
          ${s}
        `
      })
    }).pipe(re(({ data: r, errors: n }) => {
      if (n) {
        console.warn('Could not load product data', n);
        return;
      }
      return r.product;
    }));
  }

  loadProductIdByHandle({ productHandle: e }) {
    return this.fetch({
      cacheStrategy: 'public, max-age=3600, stale-while-revalidate=82800', body: JSON.stringify({
        query: `
          query @inContext(language: ${this.language}, country: ${this.country}) {
            productByHandle(handle: "${e}") {
              id
            }
          }
        `
      })
    }).pipe(re(({ data: t, errors: s }) => {
      var r;
      return s ? (console.warn('Could not load product id', s), 0) : t.productByHandle ? parseInt((r = t.productByHandle) == null ? void 0 : r.id.split('/').pop()) : 0;
    }));
  }

  fetch(e) {
    let t = { ...this.headers, ...e.headers }, s = e.body, r = [this.host, s, t];
    return Te(this.cache.withCache(r, e.cacheStrategy, async () => {
      let n = await window.fetch(this.host, { method: 'POST', headers: t, body: s });
      if (n.ok) return n.json();
      throw Error(`Error ${n.status}`);
    }));
  }
}, We = `
  fragment variantFields on ProductVariant {
    availableForSale
    compareAtPrice {
      amount
    }
    currentlyNotInStock
    id
    image {
      altText
      url
    }
    price {
      amount
    }
    selectedOptions {
      name
      value
    }
    title
    unitPrice {
      amount
    }
  }
`, Fe = `
  ${We}
  fragment productFields on Product {
    availableForSale
    compareAtPriceRange {
      maxVariantPrice {
        amount
      }
      minVariantPrice {
        amount
      }
    }
    featuredImage {
      altText
      url
    }
    handle
    id
    options {
      name
      values
    }
    priceRange {
      maxVariantPrice {
        amount
      }
      minVariantPrice {
        amount
      }
    }
    productType
    tags
    title
    vendor
    images(first: 100) {
      nodes {
        altText
        url
      }
    }
    variants(first: 100) {
      nodes {
        ...variantFields
      }
    }
  }
`;
var U = (0, oe.default)('wk:app');
window.headlessElements || (window.headlessElements = {
  store: new Map, define(i, e) {
    var t;
    (t = window.headlessElements) == null || t.store.set(i, e);
  }
});
var ne = class {
  constructor({ dependencies: e = [], ...t }) {
    this.stylesLoaded = !1;
    this._loaded = !1;
    this.addToCart = e => this.state.promise.addToCart(e);
    this.addAllToCart = e => this.state.promise.addAllToCart(e);
    this.addWishlistItem = e => this.state.promise.addWishlistItem(e);
    this.clearWishlist = () => this.state.promise.clearWishlist();
    this.loadProductInfo = e => this.state.promise.loadProductInfo(e);
    this.loadShopifyProduct = e => this.state.promise.loadShopifyProduct(e);
    this.loadWishlist = e => this.state.promise.loadWishlist(e);
    this.loadWishlistItem = e => this.state.promise.loadWishlistItem(e);
    this.publishWishlistEvent = e => this.state.promise.publishWishlistEvent(e);
    this.publishWishlistProductEvent = e => this.state.promise.publishWishlistProductEvent(e);
    this.removeWishlistItem = e => this.state.promise.removeWishlistItem(e);
    this.shareWishlist = e => this.state.promise.shareWishlist(e);
    this.updateWishlistItem = e => this.state.promise.updateWishlistItem(e);
    this.config = this.parseConfig(t), this.settings = this.parseSettings(t), this.routes = this.parseRoutes(), this.customer = this.config.customer.id ? {
      id: this.config.customer.id,
      email: this.config.customer.email
    } : null, U('Create app', {
      config: this.config,
      settings: this.settings,
      customer: this.customer
    }), this.events = new _, this.theme = new T({
      rootUrl: this.routes.rootUrl,
      wishlistUrl: this.routes.wishlistUrl
    }), this.initDevMode();
    let { stylesheets: s, scripts: r, iconSetUrl: n, localeUrl: o } = this.parseDependencies(e);
    U('Init dependecies', {
      dependencies: e,
      stylesheets: s,
      scripts: r,
      iconSetUrl: n,
      localeUrl: o
    }), this.initAssets({
      stylesheets: s,
      iconSetUrl: n,
      localeUrl: o
    }), this.initScripts(r), this.initLoginActionQueue(), (this.hasSession || this.settings.general.appLoading === 'EAGER') && this.load(), window.WishlistKing = this, this.events.publish({
      name: 'wk:app:created',
      data: {}
    });
  }

  get loaded() {
    return this._loaded;
  }

  get state() {
    return q(this._state);
  }

  get apis() {
    return q(this._apis);
  }

  get utils() {
    return q(this._utils);
  }

  get hasSession() {
    return !!this.getSessionId() || !!this.customer;
  }

  get isLoggedIn() {
    var e;
    return !!((e = this.customer) != null && e.id);
  }

  getSessionId() {
    let e = window.localStorage.getItem('wk_session_id');
    if (e) return e;
    let t = window.localStorage.getItem('appmate-session');
    if (t) try {
      let s = JSON.parse(t).state.sid;
      return this.setSessionId(s);
    } catch (s) {
      console.error(s);
    }
  }

  setSessionId(e) {
    var t;
    return window.localStorage.setItem('wk_session_id', e), (t = this._apis) == null || t.tracking.setSessionId(e), e;
  }

  async load() {
    return this._loadPromise ? this._loadPromise : (U('Load remaining app code'), this._loadPromise = (async () => {
      let [{ WishlistState: e }, { ShopifyApi: t, WishlistApi: s, TrackingApi: r }, {
        MoneyUtil: n,
        UrlUtil: o,
        ProductUtil: a
      }] = await Promise.all([import('https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.29.7/state.js'), import('https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.29.7/api.js'), import('https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.29.7/utils.js')]);
      this.initUtils({ MoneyUtil: n, UrlUtil: o, ProductUtil: a }), this.initApis({
        WishlistApi: s,
        ShopifyApi: t,
        TrackingApi: r
      }), await this.initState({ WishlistState: e }), this.initCustomerSession(), this.initUrlChangeEvents(), this.trackCurrentPage(), this._loaded = !0, this.events.publish({
        name: 'wk:app:loaded',
        data: {}
      });
    })());
  }

  initUtils({ UrlUtil: e, MoneyUtil: t, ProductUtil: s }) {
    this._utils = {
      url: new e({
        rootUrl: this.routes.rootUrl,
        wishlistUrl: this.routes.wishlistUrl,
        shopDomain: this.config.shop.domain,
        placeholderImageUrl: this.config.products.fallbackImage,
        fileUrl: this.routes.fileUrl
      }),
      money: new t({
        moneyFormat: this.config.shop.moneyFormat,
        moneyFormatWithCurrency: this.config.shop.moneyFormatWithCurrency
      }),
      product: new s
    };
  }

  initApis({ WishlistApi: e, ShopifyApi: t, TrackingApi: s }) {
    var r, n, o;
    this._apis = {
      wishlist: new e({
        host: this.config.routes.apiHost,
        shop: this.config.shop.permanentDomain,
        customerId: (r = this.config.customer.id) != null ? r : void 0,
        sessionId: this.getSessionId(),
        trackingSource: this.theme.getPageType(),
        productMetafields: this.config.products.metafields
      }),
      shopify: new t({ host: window.Shopify.routes.root.substring(0, window.Shopify.routes.root.length - 1) }),
      storefront: this.config.storefront ? new j({
        accessToken: this.config.storefront.accessToken,
        version: this.config.storefront.version,
        country: window.Shopify.country.toUpperCase(),
        language: window.Shopify.locale.split('-')[0].toUpperCase(),
        storeName: this.config.shop.permanentDomain.replace('.myshopify.com', '')
      }) : void 0,
      tracking: new s({
        notifyHost: this.config.routes.apiHost,
        events: this.events,
        shop: this.config.shop.permanentDomain,
        customerId: (n = this.config.customer.id) != null ? n : void 0,
        customerEmail: (o = this.config.customer.email) != null ? o : void 0,
        sessionId: this.getSessionId(),
        utils: this.utils,
        theme: this.theme,
        settings: this.settings
      })
    };
  }

  initState({ WishlistState: e }) {
    return this._state = new e({
      wishlistApi: this.apis.wishlist,
      shopifyApi: this.apis.shopify,
      storefrontApi: this.apis.storefront,
      settings: this.settings,
      events: this.events,
      utils: this.utils
    }), this._state.init();
  }

  async initAssets({ stylesheets: e, iconSetUrl: t, localeUrl: s }) {
    if (!(e != null && e.length) && !t) {
      this.onStylesLoaded();
      return;
    }
    let r = a => new Promise((c, d) => {
        let l = document.createElement('link');
        l.rel = 'stylesheet', l.href = a, l.onload = c, l.onerror = d, document.head.appendChild(l);
      }),
      n = a => Promise.all([import('https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.29.7/components/icon.js'), import(a)]).then(([{ Icon: c }, { icons: d }]) => {
        if (typeof d != 'object') throw new Error('Icon set must export icons object.');
        c.addIcons(d);
      }), o = a => {
        if (a.includes('.json')) return fetch(a).then(c => c.json()).then(c => {
          this.theme.locale.initLocale(c);
        });
        if (a.includes('.js')) return import(a).then(({ default: c }) => {
          this.theme.locale.initLocale(c);
        });
      };
    try {
      await Promise.all([...(e != null ? e : []).map(r), t ? n(t) : Promise.resolve(), s ? o(s) : Promise.resolve()]), this.onStylesLoaded();
    } catch (a) {
      console.warn(a), this.events.publish({ name: 'wk:app:load-styles:error', data: {} });
    }
  }

  async initScripts(e) {
    if (!(e != null && e.length)) {
      this.initDefaultEventSubscribers(), this.events.publish({ name: 'wk:app:load-scripts:success', data: {} });
      return;
    }
    try {
      await Promise.all(e.map(t => import(t).then(({ setup: s }) => {
        typeof s == 'function' && s({ app: this });
      }))), e.some(t => t.includes('event-subscribers.js')) || this.initDefaultEventSubscribers(), this.events.publish({
        name: 'wk:app:load-scripts:success',
        data: {}
      });
    } catch (t) {
      console.warn(t), this.events.publish({ name: 'wk:app:load-scripts:error', data: {} });
    }
  }

  initDefaultEventSubscribers() {
    this.events.subscribe('wk:wishlist:login-required', e => {
      window.location.href = this.routes.accountLoginUrl;
    }), this.events.subscribe('wk:customer:login', e => {
      var t;
      if ((t = e.data) != null && t.pending) switch (e.data.pending.action) {
        case'wishlist:add':
          this.addWishlistItem(e.data.pending);
      }
    }), this.events.subscribe('wk:customer:logout', async e => {
      this.clearCustomerSession();
    });
  }

  trackCurrentPage() {
    if (this.theme.getPageType() === 'wishlist') {
      let t = this.theme.getWishlistId(window.location.pathname);
      t && this.publishWishlistEvent({ eventName: 'wk:wishlist:page-view', wishlistId: t });
    }
  }

  onStylesLoaded() {
    this.stylesLoaded = !0, this.events.publish({ name: 'wk:app:load-styles:success', data: {} });
  }

  async initLoginActionQueue() {
    let e = !!window.localStorage.getItem('wk_logged_in');
    if (this.events.subscribe('wk:wishlist:login-required', t => {
      var r;
      let s = ['wishlist:add', 'wishlist:view'];
      (r = t.data) != null && r.action && s.includes(t.data.action) && window.localStorage.setItem('wk_pending', JSON.stringify({ ...t.data }));
    }), !e && this.isLoggedIn) {
      window.localStorage.setItem('wk_logged_in', '1'), await this.load(), await this.loadWishlist({
        wishlistId: 'mine',
        strategy: 'cache-or-network'
      });
      let t = this.getPendingWishlistAction();
      this.events.publish({ name: 'wk:customer:login', data: { pending: t } });
    } else e && !this.isLoggedIn && (await this.load(), window.localStorage.removeItem('wk_logged_in'), this.events.publish({
      name: 'wk:customer:logout',
      data: {}
    }));
    ['challenge', 'account'].includes(this.theme.getPageType()) || window.localStorage.removeItem('wk_pending');
  }

  async initCustomerSession() {
    this.hasSession || (await this.clearCustomerSession(), this.events.once('wk:app:init-sid', e => {
      var t, s;
      (t = e.data) != null && t.sessionId && this.setSessionId((s = e.data) == null ? void 0 : s.sessionId);
    }));
  }

  async clearCustomerSession() {
    window.localStorage.removeItem('wk_session_id'), window.localStorage.removeItem('wk_pending'), await this.state.promise.clearCache();
  }

  getPendingWishlistAction() {
    try {
      let e = window.localStorage.getItem('wk_pending');
      if (e) return JSON.parse(e);
    } catch (e) {
      console.warn('Could not parse pending wishlist action', e);
    }
  }

  initUrlChangeEvents() {
    let e = ({ productHandle: s, variantId: r }) => {
      this.events.publish({ name: 'wk:product:change-variant:success', data: { productHandle: s, variantId: r } });
    }, t = s => (...r) => {
      var h;
      let n = s.apply(history, r), o = typeof r[2] == 'string' ? r[2] : (h = r[2]) == null ? void 0 : h.toString();
      if (!o) return n;
      o.startsWith('?') && (o = window.location.pathname + o);
      let a = `${window.location.protocol}//${window.location.host}`, c = new URL(o, a),
        d = this.theme.getProductHandle(c), l = c.searchParams.get('variant');
      if (!d) return n;
      e({ productHandle: d, variantId: l ? parseInt(l) : void 0 });
    };
    history.replaceState = t(history.replaceState), history.pushState = t(history.pushState);
  }

  parseConfig({ config: e }) {
    var t, s, r, n, o, a, c, d;
    return {
      storefront: e.storefrontAccessToken && e.storefrontVersion ? {
        accessToken: e.storefrontAccessToken,
        version: e.storefrontVersion
      } : void 0,
      customer: { id: e.customerId ? e.customerId : null, email: (t = e.customerEmail) != null ? t : '' },
      shop: {
        name: (s = e.shopName) != null ? s : '',
        domain: (r = e.shopDomain) != null ? r : '',
        permanentDomain: (n = e.shopPermanentDomain) != null ? n : '',
        moneyFormat: (o = e.shopMoneyFormat) != null ? o : '',
        moneyFormatWithCurrency: (a = e.shopMoneyFormatWithCurrency) != null ? a : '',
        customerAccountsEnabled: e.shopCustomerAccountsEnabled
      },
      routes: {
        apiHost: (c = e.apiHost) != null ? c : 'https://api.appmate.io/v2',
        rootUrl: window.Shopify.routes.root,
        fileUrl: e.fileUrl
      },
      products: {
        fallbackImage: (d = e.productFallbackImage) != null ? d : '//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=webp&v=1530129081',
        metafields: !!e.productMetafields
      }
    };
  }

  parseSettings({ settings: e }) {
    var t, s, r, n, o, a, c, d, l, h, p, y, I, m, u, w, b, W, C, O, S, F, A, x, B, J, K;
    return {
      general: {
        appLoading: (s = (t = e == null ? void 0 : e.general) == null ? void 0 : t.appLoading) != null ? s : 'LAZY',
        wishlistAccessMode: (n = (r = e == null ? void 0 : e.general) == null ? void 0 : r.wishlistAccessMode) != null ? n : 'UNRESTRICTED',
        wishlistMode: (a = (o = e == null ? void 0 : e.general) == null ? void 0 : o.wishlistMode) != null ? a : 'PRODUCT',
        wishlistPath: (d = (c = e == null ? void 0 : e.general) == null ? void 0 : c.wishlistPath) != null ? d : '/apps/wishlist'
      },
      money: { withCurrency: (h = (l = e == null ? void 0 : e.money) == null ? void 0 : l.withCurrency) != null ? h : !1 },
      integrations: {
        googleAnalytics: {
          enabled: (I = (y = (p = e.integrations) == null ? void 0 : p.googleAnalytics) == null ? void 0 : y.enabled) != null ? I : !1,
          tracker: (w = (u = (m = e.integrations) == null ? void 0 : m.googleAnalytics) == null ? void 0 : u.tracker) != null ? w : ''
        },
        klaviyo: { enabled: (C = (W = (b = e.integrations) == null ? void 0 : b.klaviyo) == null ? void 0 : W.enabled) != null ? C : !1 },
        metaPixel: { enabled: (F = (S = (O = e.integrations) == null ? void 0 : O.metaPixel) == null ? void 0 : S.enabled) != null ? F : !1 },
        wishlistAnalytics: { enabled: (B = (x = (A = e.integrations) == null ? void 0 : A.metaPixel) == null ? void 0 : x.enabled) != null ? B : !0 }
      },
      cache: {
        wishlist: { ttl: 6e4 },
        wishlistItem: { ttl: 6e4 },
        productInfo: { ttl: 6e4 },
        product: { ttl: 3e4 },
        cart: { ttl: 1e3 }
      },
      colorMap: (J = e.colorMap) != null ? J : {},
      collectionButtons: (K = e.collectionButtons) != null ? K : {}
    };
  }

  parseRoutes() {
    let e = this.config.routes.rootUrl;
    return {
      rootUrl: e,
      fileUrl: this.config.routes.fileUrl,
      wishlistUrl: e + this.settings.general.wishlistPath.split('/').filter(t => !!t).join('/'),
      accountUrl: e + 'account',
      accountLoginUrl: e + 'account/login',
      accountLogoutUrl: e + 'account/logout',
      accountRegisterUrl: e + 'account/register',
      accountAddressesUrl: e + 'account/addresses',
      collectionsUrl: e + 'collections',
      allProductsCollectionUrl: e + 'collections/all',
      searchUrl: e + 'search',
      predictiveSearchUrl: e + 'search/suggest',
      cartUrl: e + 'cart',
      cartAddUrl: e + 'cart/add',
      cartChangeUrl: e + 'cart/change',
      cartClearUrl: e + 'cart/clear',
      cartUpdateUrl: e + 'cart/update',
      productRecommendationsUrl: e + 'recommendations/products'
    };
  }

  parseDependencies(e) {
    let t = this.isDevMode();
    return e.map(s => this.parseDependencyUrl({ url: s, noCache: t })).reduce(({
                                                                                 stylesheets: s,
                                                                                 scripts: r,
                                                                                 iconSetUrl: n,
                                                                                 localeUrl: o
                                                                               }, a) => {
      let [c] = a.split('?');
      return c.includes('locale-') ? o = a : c.endsWith('icons.js') ? n = a : c.endsWith('.js') ? r.push(a) : c.endsWith('.css') && s.push(a), {
        stylesheets: s,
        scripts: r,
        iconSetUrl: n,
        localeUrl: o
      };
    }, { stylesheets: [], scripts: [], iconSetUrl: '', localeUrl: '' });
  }

  parseDependencyUrl({ url: e, noCache: t }) {
    return t && !e.includes('/_templates/') ? e.replace('cdn.appmate.io', 'storage.googleapis.com/appmate-cdn').replace(/v=\d*/, `v=${Date.now()}`) : e;
  }

  isDevMode() {
    if (!!!document.getElementById('preview-bar-iframe')) return !1;
    let t = window.localStorage.getItem('wk_dev_mode');
    return t ? Date.now() - parseInt(t) < 8 * 36e5 : !1;
  }

  initDevMode() {
    window.location.search.includes('wk_dev_mode=on') ? (U('Activate dev mode'), window.localStorage.setItem('wk_dev_mode', Date.now().toString())) : window.location.search.includes('wk_dev_mode=off') && (U('Deactivate dev mode'), window.localStorage.removeItem('wk_dev_mode')), this.isDevMode() && (U('Dev mode active'), window.addEventListener('message', e => {
      switch (e.data) {
        case'WK_THEME_RELOAD':
          window.localStorage.setItem('wk_dev_mode', Date.now().toString()), window.location.reload();
          break;
      }
    }, !1));
  }
}, q = i => {
  if (!i) throw new Error('Wishlist app not loaded.');
  return i;
};
export { ne as WishlistApp };
